// 6e4 is the number 60000 - it's called "scientific notation" and equals 6*10^4
const MINUTES_ON_MILLISECONDS = 6e4

export default MINUTES_ON_MILLISECONDS

export const DATE_DIGITS = {
  TWO: "2-digit"
} as const
